import { render, staticRenderFns } from "./payslip.vue?vue&type=template&id=3c844d36&scoped=true&"
import script from "./payslip.vue?vue&type=script&lang=js&"
export * from "./payslip.vue?vue&type=script&lang=js&"
import style0 from "./payslip.vue?vue&type=style&index=0&id=3c844d36&lang=less&scoped=true&"
import style1 from "./payslip.vue?vue&type=style&index=1&id=3c844d36&lang=less&scoped=true&"
import style2 from "./payslip.vue?vue&type=style&index=2&id=3c844d36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c844d36",
  null
  
)

export default component.exports